import React, { FunctionComponent, useState } from 'react';
import { Connection, SupplyPeriodDetails, SupplyPeriodSummary } from '../connectionsApi';
import AuthorizedAction from '../../common/AuthorizedAction';
import { Widget } from '../../dashboard/Dashboard';
import { Permission } from '../../../auth/getPermissions';
import ExpectedChargeComponentsForm from './ExpectedChargeComponentsForm';
import { EuiBasicTable, EuiModal } from '@elastic/eui';

interface ExpectedChargeComponentsProps {
  connection: Connection;
  supplyPeriod?: SupplyPeriodSummary;
  supplyPeriodV3?: SupplyPeriodDetails;
}

const ExpectedChargeComponents: FunctionComponent<ExpectedChargeComponentsProps> = ({
  connection,
  supplyPeriod,
  supplyPeriodV3,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (!supplyPeriod || !supplyPeriodV3) {
    // no point in continuing without supply period but make it pretty
    return (
      <Widget
        className="apl-mt-none"
        headerComponent={
          <h3 className="apl-h3 widget__title widget__title--inline apl-mb-none">
            Expected charge components
          </h3>
        }
        width="full"
      >
        <p className="widget__list-item">Missing Supply Period</p>
      </Widget>
    );
  }

  return (
    <>
      <Widget
        className="apl-mt-none"
        headerComponent={
          <h3 className="apl-h3 widget__title widget__title--inline apl-mb-none">
            Expected charge components
            <AuthorizedAction
              extraClasses="apl-ml-l"
              onClick={() => setModalOpen(true)}
              permission={Permission.CONNECTION_EDIT}
            >
              Edit
            </AuthorizedAction>
          </h3>
        }
        width="full"
      >
        {
          <EuiBasicTable
            style={{ maxWidth: 470 }}
            columns={[
              {
                field: 'tag',
                name: 'Charge Tag',
              },
              {
                field: 'flow',
                name: 'Flow Direction',
              },
            ]}
            items={supplyPeriodV3.expectedChargeComponents ?? []}
          />
        }
      </Widget>
      {modalOpen && (
        <EuiModal onClose={() => setModalOpen(false)}>
          <ExpectedChargeComponentsForm
            connection={connection}
            supplyPeriod={supplyPeriod}
            supplyPeriodV3={supplyPeriodV3}
            onSubmit={() => setModalOpen(false)}
            onCancel={() => setModalOpen(false)}
          />
        </EuiModal>
      )}
    </>
  );
};

export default ExpectedChargeComponents;
